<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--<v-container grid-list-md text-xs-center class="fluid">-->
    <v-container grid-list-sm fluid class="mt-3" style="background:#FAFAFA">
        <v-container class="border-radius mt-5" style="padding-right:25px!important;padding-left:25px!important">
            <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
            <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
            <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
            <!-- ========================================================================================= -->
            <div>
                <div>
                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                        <div data-v-221edead="" class="d-flex flex-column flex-lg-column-reverse" v-if="isDesktop()">
                            <div data-v-221edead="" class="container">
                                <div data-v-221edead="" class="row">
                                    <div data-v-221edead="" class="col-lg-12">
                                        <div data-v-221edead="" class="results-header mt-5">
                                            <p data-v-221edead="">{{ $t('list_devis.list_devis_title[0]') }} <strong data-v-221edead="">{{ $t('list_devis.list_devis_title[1]') }}</strong> {{ $t('list_devis.list_devis_title[2]') }} {{listdevis.length}} {{ $t('list_devis.list_devis_title[3]') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div data-v-221edead="" class="mt-5 d-flex flex-column flex-lg-column-reverse" v-if="isMobile()">
                            <div data-v-221edead="" class="container">
                                <div data-v-221edead="" class="row">
                                    <div data-v-221edead="" class="col-lg-12">
                                        <div data-v-221edead="" class="results-header mt-5">
                                            <p data-v-221edead="">{{ $t('list_devis.list_devis_title[0]') }} <strong data-v-221edead="">{{ $t('list_devis.list_devis_title[1]') }}</strong> {{ $t('list_devis.list_devis_title[2]') }} {{listdevis.length}} {{ $t('list_devis.list_devis_title[3]') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div data-v-221edead="" class=" mt-5">
                            <div class="row" v-if="isDesktop()">
                                <div class="col-lg-4" v-for="(devis,index) in listdevis" :key="index">
                                <div class="pricing-box rounded text-center p-4">
                                        <div class="lightning-box mb-3 text-center" v-if="brancheTocheck == 'Automobile'">
                                            <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color: #ffffff;">
                                                <span v-if="devis.is_car_attestation_ready">
                                                    <img src="../assets/img/lightning.png" alt="lightning_logo">
                                                </span>
                                            </span>
                                        </div>

                                        <div v-if="devis.reduction" class="reduction-box mb-3 text-center">
                                            <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color: #ffffff;">
                                                 <span style="font-weight: 350;font-size: 15px;margin-top: -10px;">{{ $t('paiement.coupon_section.label_reduction_label') }}</span>
                                                 <span style="font-weight: 400;font-size: 15px;margin-bottom: -10px;">{{ devis.reduction.montant }} {{ devis.reduction.type === 'pourcentage' ? '%' : 'FCFA' }}</span>
                                            </span>
                                        </div>
                                    
                                    <div>
                                        <img :src="devis.image" width="80" height="80" alt="logo_assureur" style="border-radius: 10px;">
                                    </div>
                                    <h4 class="title mb-3">{{ devis.societe }}</h4>
                                    <h1 class="font-weight-bold mb-0 mt-3">
                                    <b>
                                        {{ devis.tarif.toLocaleString() }} FCFA
                                    </b>
                                    </h1>
                                    <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(devis)">{{ $t('list_devis.souscrire_label') }}</a>
                                    <div class="justify-content-center row mt-3">
                                        <a class="button-function" href="javascript: void(0);" @click="Download_devis(devis)">{{ $t('list_devis.telecharger_label') }}</a>
                                        <a class="button-function ml-3" href="javascript: void(0);" @click="SendDevisByMail(devis)">{{ $t('list_devis.devis_par_mail') }}</a>
                                    </div>
                                    <div class="justify-content-center row mt-3 mb-3">
                                        <a class="button-function" href="javascript: void(0);" @click="assistanceDialogManip(devis)">{{ $t('list_devis.etre_rappele_label') }}</a>
                                        <a v-if="brancheTocheck == 'Automobile'" class="button-function ml-3" href="javascript: void(0);" @click="showDetailAuto(devis)">{{ $t('list_devis.detail_label') }}</a>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div class="row" v-if="isMobile()">
                                <div class="col-lg-12" v-for="(devis,index) in listdevis" :key="index">
                                <div class="pricing-box rounded text-center p-4">
                                        <div class="lightning-box mb-3 text-center" v-if="brancheTocheck == 'Automobile'">
                                            <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color: #ffffff;">
                                                 <span><img v-if="devis.is_car_attestation_ready" src="../assets/img/lightning.png" alt="lightning_logo"></span>
                                            </span>
                                        </div>
                                      <div v-if="devis.reduction" class="mb-3 reduction-box text-center">
                                            <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color:#ffffff;">
                                                 <span style="font-weight: 350;font-size: 15px;margin-top: -10px;">{{ $t('paiement.coupon_section.label_reduction_label') }}</span>
                                                 <span style="font-weight: 400;font-size: 15px;margin-bottom: -10px;">{{ devis.reduction.montant }} {{ devis.reduction.type === 'pourcentage' ? '%' : 'FCFA' }}</span>
                                            </span>
                                        </div>
                                    <div>
                                        <img :src="devis.image" width="80" height="80" alt="logo_assureur" style="border-radius: 10px;">
                                    </div>
                                    <h4 class="title mb-3">{{ devis.societe }}</h4>
                                    <h1 class="font-weight-bold mb-0 mt-3">
                                    <b>
                                        {{ devis.tarif.toLocaleString() }} FCFA
                                    </b>
                                    </h1>
                                    <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(devis)">{{ $t('list_devis.souscrire_label') }}</a>
                                    <div class="mt-3">
                                        <ul>
                                            <li><a class="button-function" href="javascript: void(0);" @click="Download_devis(devis)">{{ $t('list_devis.telecharger_label') }}</a></li>
                                            <li class="mt-2"><a class="button-function" href="javascript: void(0);" @click="SendDevisByMail(devis)">{{ $t('list_devis.devis_par_mail') }}</a></li>
                                            <li class="mt-2"><a class="button-function" href="javascript: void(0);" @click="assistanceDialogManip(devis)">{{ $t('list_devis.etre_rappele_label') }}</a></li>
                                            <!-- <li class="mt-2"><a class="button-function" href="javascript: void(0);" @click="showDetailAuto()">Afficher détails</a></li> -->
                                        </ul>
                                    </div>
                                   
                                </div>
                                </div>
                            </div>
                                                             
                        </div>

                   </div>
                </div>
                <!-- popup pour demande d'assistance -->
                <!-- popup pour demande d'assistance -->
                <v-dialog v-model="assistanceDialog" max-width="800">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance">
                              <div>
                                  <div class="loan-group loan-group-0">
                                      <div class="fields">
                                          <div class="field-title font-weight-bold">{{ $t('list_devis.assistance_form.assistance_title') }}</div>
                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="HoraireRappel" class="field-label">{{ $t('list_devis.assistance_form.horaire_rappel_label') }}</label>
                                                      <select id="HoraireRappel" name="infosAssis" class="field-select" v-model="horaire">
                                                          <option v-for="itm in itema" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="CanalRappel" class="field-label">{{ $t('list_devis.assistance_form.canal_rappel_label') }}</label>
                                                      <select id="CanalRappel" name="infosAssis" class="field-select" v-model="canal">
                                                          <option v-for="itm in rappel" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="nom" class="field-label">{{ $t('list_devis.assistance_form.nom_label') }}</label>
                                                      <input v-model="name" :placeholder="$t('list_devis.assistance_form.nom_placeholder')" id="nom" name="infosAssis" class="field-input">
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="num" class="field-label">
                                                        {{ $t('list_devis.assistance_form.telephone_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.telephone_placeholder')" v-model="tel" id="num" name="infosAssis" class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Object" class="field-label">
                                                        {{ $t('list_devis.assistance_form.objet_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.objet_placeholder')" v-model="objetRappel" id="Object" name="infosAssis" disabled class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Remarque" class="field-label">
                                                        {{ $t('list_devis.assistance_form.remarque_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <textarea rows="4" cols="50" :placeholder="$t('list_devis.assistance_form.remarque_placeholder')" v-model="remarques" id="Remarque" name="infosAssis" class="field-input"></textarea>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-left">
                              <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                          <div class="wizard-footer-right">
                              <button @click="AddAssistance()" type="button" class="wizard-btn">
                                {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>

                <!-- popup pour afficher les infos du véhicule -->
                <!-- popup pour afficher les infos du véhicule -->
                <v-dialog v-model="infoVehiculeModal" max-width="500">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                              <div>
                                  <div class="loan-group loan-group-0">
                                      <div class="fields">
                                          <div class="field-title font-weight-bold">{{ $t('list_devis.info_vehicule_title') }}</div>
                                          <div class="ml-4 row">
                                             <p v-html="infoVehicule"></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-left">
                              <button @click="infoVehiculeModal = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>
            </div>

        </v-container>


        <!-- Modal loader start-->
         <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('paiement.sante.popup_file_generator.title') }}</span>
    </div>

        <!-- <div class="text-xs-center">
            <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
                <v-card color="orange" dark>
                    <v-card-text>
                        {{ $t('paiement.sante.popup_file_generator.title') }}
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div> -->
    </v-container>
</template>

<script>
    import Api from '../services/Api'
    import store from "../store/store";
    import {mapGetters} from 'vuex'
    import PushInDataLayer from '../services/TagManager'
    import listeTalonFromPartenerApi from "../common/TalonDigitalPartener.json"


    export default {
        name: "ListDevis",
        data() {
            return {
                listeTalonFromPartener: listeTalonFromPartenerApi,
                primeBeforeReduction : 0,
                shownTextReduction : false,
                typeReduction : "",
                reductionPurcent : "",
                reductionMount : "",
                textCouponFinale : "",
                showReduction : false,
                prime_ttc_before_reduc : 0,
                dialogCouponLoading : false,
                hideCoupon : false,
                codeReduction : null,
                couponswitch : false,
                ShowPopupCoupon : false,

                ifDevisIsAuto: false,
                ecommerce:[],
                devis_price:null,
                HideDive: null,
                HideButton: true,
                devisVoyage: [],
                listdevis: [],
                DevisFinal: [],
                assureurs: [],
                assistanceDialog: false,
                infoVehiculeModal: false,
                infoVehicule : null,
                notif: null,
                GtmAssistanceVal:{},
                dialogLoading: false,
                brancheTocheck: '',
                Mano: null,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                headers: [
                    {text: 'Assureurs', align: 'left', sortable: false, value: 'societe'},
                ],
                itema: ['Le plus tôt possible', 'Dans la matinée', 'Dans la journée'],
                rappel: ['Whatsapp', 'Appel', 'Email'],
                objet: ['Devis', 'Souscription', 'Contrat', 'Paiement', 'Conseil', 'Sinistre', 'Autres'],
                horaire: null,
                canal: null,
                name: null,
                tel: null,
                objetRappel: null,
                remarques: null,
                timer: '',
                ExitByUser: true
            }
        },
        computed: {
            ...mapGetters([
                'username'
            ])
        },
        created() {
            this.fetchEventsList();
            this.timer = setInterval(this.fetchEventsList, 60000)
        },

        methods: {
            checkCodeReductionForDevis(){
                let Dernierdevis = this.$store.state.devis.result.devis;
                 for(let devis of Dernierdevis) {
                    let CouponReductionData = {
                        coupon_code : null,
                        brancheid: devis.brancheid._id,
                        partenaireid : devis.partenaireid,
                        courtierid: null,
                        numero_police: devis.numeroDevis,
                        dateSouscription : devis.dateSouscription,
                        code_partenaire: devis.codep,
                        prime_ttc : devis.prime_ttc,
                        plateforme : "Front",
                        clientid : this.$store.state.user._id,
                        dateEffet : devis.dateEffet
                    }

                    Api().post("coupons/check/reduction", CouponReductionData)
                        .then((result) => {
                            if (result.data.status == true) {
                                // Trouver le devis correspondant dans listdevis
                                let found = this.listdevis.find(d => d.numero === devis.numeroDevis);
                                if (!found) return;

                                const resp = result.data;
                                const coupons = Array.isArray(resp.applicableCoupons) ? resp.applicableCoupons : [];

                                // Définir l'ordre de priorité
                                const priorityOrder = [1, 2, 3];

                                let best = null;

                                if (coupons.length > 0) {
                                    // Chercher le 1er niveau de priorité disponible, puis sélectionner le meilleur discount
                                    for (let i = 0; i < priorityOrder.length; i++) {
                                        const level = priorityOrder[i];
                                        const levelCoupons = coupons.filter(c => Number(c.priorityLevel) === level);
                                        if (levelCoupons.length > 0) {
                                            best = levelCoupons.reduce((acc, cur) => {
                                                const accAmt = acc ? Number(acc.discountAmount) : -Infinity;
                                                const curAmt = Number(cur.discountAmount);
                                                return (curAmt > accAmt) ? cur : acc;
                                            }, null);
                                            break; // on s'arrête au premier niveau trouvé
                                        }
                                    }
                                }

                                // Fallback si aucun applicableCoupons, utiliser resp.coupon
                                if (!best && resp.coupon) {
                                    best = {
                                        reductionType: String(resp.coupon.type || '').toUpperCase(), // 'VALEUR' ou 'POURCENTAGE'
                                        reductionValue: resp.coupon.reduction, // % ou montant selon type
                                        discountAmount: (typeof resp.discountAmount !== 'undefined') ? resp.discountAmount : resp.coupon.reduction, // montant en FCFA si type valeur
                                        primeAfter: resp.prime_apres
                                    };
                                }

                                if (best) {
                                    const isPercent = String(best.reductionType).toUpperCase() === 'POURCENTAGE';
                                    const typeMapped = isPercent ? 'pourcentage' : 'valeur';

                                    // Pour le rendu:
                                    // - type 'valeur' => afficher discountAmount (FCFA)
                                    // - type 'pourcentage' => afficher reductionValue (%)
                                    const montant = isPercent ? best.reductionValue : best.discountAmount;

                                    this.$set(found, 'reduction', {
                                        montant: montant,
                                        type: typeMapped
                                    });

                                    // Si vous souhaitez aussi afficher la prime après réduction, décommentez:
                                    // if (typeof best.primeAfter !== 'undefined') {
                                    //     found.tarif = best.primeAfter;
                                    // }
                                }
                            }
                        }).catch((err) => {
                            console.log(':::::::::: error response coupon :::::::::::::', err)
                            this.showReduction = false;
                            this.shownTextReduction = false
                        })
                    }
                },
            showDetailAuto(devis){
                if(this.ifDevisIsAuto == false){
                    this.infoVehicule = devis.matchingArray
                    //this.ifDevisIsAuto = true
                    this.infoVehiculeModal = true

                }else{
                    this.ifDevisIsAuto = false
                }

            },

            fetchEventsList() {
                this.Mano = this.Mano - 1;
                if (this.Mano == 0) {
                    this.ExitByUser = false;
                    this.$store.dispatch('setDevis', null);
                    this.$router.push('/')
                }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isTablette() {
                if (screen.width > 425 && screen.width <= 768) {
                    return true
                } else {
                    return false
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            assistanceDialogManip(devis)
            {
                this.devis_price = devis.tarif

                this.GtmAssistanceVal.branche = devis.branche.toLowerCase()
                this.GtmAssistanceVal.insurer_name = devis.nom
                this.GtmAssistanceVal.step = 1
                this.GtmAssistanceVal.event = 'receive_call_step1'

                PushInDataLayer(this.GtmAssistanceVal)

                this.objetRappel = 'Devis : ' + devis.numero;
                this.name = store.state.user.prenom.toUpperCase() + '-' + store.state.user.nom.toUpperCase();
                this.tel = store.state.user.telephone_port;
                this.assistanceDialog = true
            },

            AddAssistance()
            {
                if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                    const assist = {
                        horaire: this.horaire,
                        canal: this.canal,
                        name: this.name,
                        tel: this.tel,
                        objetRappel: this.objetRappel,
                        remarques: this.remarques,
                        userid: store.state.user._id
                    };

                    let Gtm2 = {
                        branche : this.GtmAssistanceVal.branche,
                        schedule : this.horaire,
                        insurer_name : this.GtmAssistanceVal.insurer_name,
                        step : 2,
                        price : this.devis_price,
                        channel :this.canal,
                        event : 'receive_call_step2'
                    }

                    Api().post('assistances/create', assist)
                        .then(resp => {
                            PushInDataLayer(Gtm2)
                            if (resp.data.info == 'ok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                this.assistanceDialog = false;
                                this.horaire = '';
                                this.canal = '';
                                this.name = '';
                                this.tel = '';
                                this.objetRappel = '';
                                this.remarques = ''
                            } else if (resp.data.info == 'nok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabError)
                            }
                        })

                } else {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                }

            },

            getPartner: function (assur) {
                let partenaire = this._.find(this.$store.state.devis.result.partenaire, function (o) {
                    return o._id === assur
                });
                return partenaire
            },

            btn1_clicked: function (item)
            {
                let Gtmval = {
                    branche:item.branche.toLowerCase(),
                    insurer_name:item.nom,
                    price:item.tarif,
                    event:'view_price'
                }

                PushInDataLayer(Gtmval)

                this.HideDive = item.id;
                this.HideButton = item.id + 'hidden'
            },

            btn2_clicked: function (devis) {
                Api().get('devis/' + devis.id)
                    .then(response => {
                        this.$store.dispatch('setDevisPayement', response.data);
                        this.$router.push('/payement')
                    })
            },

            btn3_clicked: function () {
                this.HideDive2 = true;
                this.HideButton2 = false;
            },

            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../assets/img/assuraf_sm.png')
                }
            },

            SendDevisByMail: function (devis)
            {
                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'quote_by_mail'
                }

               PushInDataLayer(Gtmval)

                Api().get('devis/mydevisbyemail/' + devis.id)
                .then(response => {
                    this.notif = response.data.info
                })
            },

            Download_devis: function (devis){

                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'download_quote'
                }

               PushInDataLayer(Gtmval)
               this.dialogLoading = true;
                Api().get('devis/download/' + devis.id)
                    .then(response => {
                        let url = response.data.lien;
                        let WinOpener = null
                       this.dialogLoading = false, WinOpener = window.open(),WinOpener.location = url
                        })
            },

            DataLayerPusherCheckValue(tab,val){
                let checker = 0
                for(let t of tab)
                {
                    if(t.item_id==val)
                    {
                        checker = 1
                    }
                }
                return checker
            },

            sanitizeHtml(html) {
                if (!html) return '';
                const root = document.createElement('div');
                root.innerHTML = html;
                const allowed = new Set(['B','I','EM','STRONG','UL','OL','LI','BR','P','SPAN']);
                const walk = (node) => {
                    const children = Array.from(node.childNodes);
                    for (const child of children) {
                        if (child.nodeType === 1) {
                            const tag = child.tagName.toUpperCase();
                            if (!allowed.has(tag)) {
                                const text = document.createTextNode(child.textContent || '');
                                node.replaceChild(text, child);
                                continue;
                            }
                            Array.from(child.attributes).forEach(attr => {
                                const name = attr.name.toLowerCase();
                                const value = attr.value || '';
                                if (name.startsWith('on') || /javascript:/i.test(value)) {
                                    child.removeAttribute(attr.name);
                                }
                            });
                            walk(child);
                        } else if (child.nodeType === 8) {
                            node.removeChild(child);
                        }
                    }
                };
                walk(root);
                return root.innerHTML;
            },

        },
        beforeDestroy() {
            clearInterval(this.timer);
            if (this.ExitByUser == true) {
                this.$store.dispatch('setDevis', null)
            }

        },
        watch: {
            notif: function () {
                if (this.notif == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par mail !', this.ToastTabSucess);
                    this.notif = null
                } else if (this.notif == 'nok') {
                    this.$toasted.show("L'envoi du devis par mail a échoué !", this.ToastTabError);
                    this.notif = null
                }
            }
        },
        mounted() {
        console.log(';;;;;;;; dernier Devis ;;;;;;;;', this.$store.state.devis.result.devis)
            window.scrollTo(0, 0);
            let dernierDevis = [];
            if (this.$store.state.devis && this.$store.state.user) {
                this.Mano = 20;
                
                dernierDevis = this.$store.state.devis.result.devis;
                this.assureurs = this.$store.state.devis.result.partenaire;
                
                let branche = this.$store.state.devis.result.branche;
                this.brancheTocheck = this.$store.state.devis.result.branche.branche;
                let items = []
                this.checkCodeReductionForDevis()
                localStorage.setItem('item_list_name', 'Devis créés')
                if (branche.branche == 'Habitation') { // Test if Branche==Habitation

                    for (let ass of this.assureurs)
                    {
                        for (let dev of dernierDevis)
                        {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance habitation',
                                    'item_id': dev.numeroDevis,
                                    'price': Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length+1,
                                    'quantity':1,
                                })

                                this.listdevis.push({
                                    reduction : null,
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Habitation',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    typeBien: dev.typeBien,
                                    naturecouverture: dev.naturecouverture,
                                    valeurbatiment: dev.valeurbatiment,
                                    valeurcontenu: dev.valeurcontenu,
                                    qualiteassure: dev.qualiteassure,
                                    nombrepiece: dev.nombrepiece,
                                    nombreetage: dev.nombreetage,
                                    garanties: dev.garanties,
                                    optionAss: ['Assistance', 'Remplacement', 'Orientation sinistre']

                                })
                            }
                        }
                    }
                } else if (branche.branche == 'Voyage') { // Dans le cas de voyage on cree un tableau avec des libelles pour voyage
                    for (let ass of this.assureurs) {
                        for (let dev of dernierDevis) {

                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance voyage',
                                    'item_id': dev.numeroDevis,
                                    'price':Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length,
                                    'quantity':1,
                                })

                                this.listdevis.push({
                                    reduction : null,
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Voyage',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    nbpassager: dev.nbpassager,
                                    pays_domicile: dev.vpays_domicile,
                                    destination: dev.destination,
                                    garanties: dev.garanties,
                                    optionAss: ['Assistance', 'Remplacement', 'Orientation sinistre']
                                    // Autres completer a la suite

                                })
                            }
                        }
                    }
                } else if (branche.branche == 'Automobile') { // Dans le cas de voyage on cree un tableau avec des libelles pour Auto
                    for (let ass of this.assureurs) {
                        for (let dev of dernierDevis)
                        {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance automobile',
                                    'item_id': dev.numeroDevis,
                                    'price': Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length,
                                    'quantity':1,
                                })
                                this.listdevis.push({
                                    reduction : null,
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    is_car_attestation_ready : ass.is_car_attestation_ready,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Automobile',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    vehicul: dev.vehicules,
                                    garanties: dev.garanties,
                                    matchingArray: dev.ArrayStringGaranties
                                    // Autres completer a la suite

                                })
                            }
                        }
                    }
                }else if(branche.branche == 'Santé') {

                    for (let ass of this.assureurs)
                    {
                        for (let dev of dernierDevis)
                        {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance santé',
                                    'item_id': dev.numeroDevis,
                                    'price': Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length+1,
                                    'quantity':1,
                                })

                                this.listdevis.push({
                                    reduction : null,
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Santé',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,

                                })
                            }
                        }
                    }
                } else if(branche.branche == 'Responsabilité Civile Scolaire') {
                     for (let ass of this.assureurs) {
                        for (let dev of dernierDevis)
                        {
                            if (ass._id == dev.partenaireid)
                            {
                                items.push({
                                    'item_name': 'Assurance automobile',
                                    'item_id': dev.numeroDevis,
                                    'price': Math.round(dev.prime_ttc/655.957),
                                    'item_brand':ass.societe,
                                    'item_category': branche.branche,
                                    'item_list_name': 'Devis créés',
                                    'index': items.length,
                                    'quantity':1,
                                })
                                this.listdevis.push({
                                    reduction : null,
                                    id: dev._id,
                                    numero: dev.numeroDevis,
                                    is_car_attestation_ready : ass.is_car_attestation_ready,
                                    image: ass.logo,
                                    nom: ass.societe,
                                    branche:'Automobile',
                                    tarif: dev.prime_ttc,
                                    prime_nette: dev.prime_nette,
                                    dateEffet: dev.dateEffet,
                                    dateEcheance: dev.dateEcheance,
                                    vehicul: dev.vehicules,
                                    garanties: dev.garanties,
                                    matchingArray: dev.ArrayStringGaranties
                                    // Autres completer a la suite

                                })
                            }
                        }
                    }
                }

                if(document.readyState=='complete')
                {
                    localStorage.setItem('EcommercePushed',true)
                        PushInDataLayer({
                            'event': 'view_item_list',
                            'ecommerce':{
                            items
                        }
                    })
                }
            } else {
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
    @import "../assets/css/liste_devis.css";
    @import "../assets/css/liste_devis_button.css";
    @import "../assets/css/devis_css.css";
    /* .container {
          padding: 0px !important;
      } */
    .row-container {
        background: white;
    }

    .List-garanties-option li {
        list-style: none;
        border-bottom: 1px solid lightgrey;
    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .greyLabel {
        color: grey
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 90%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important
    }

    .focusablee :hover {
        background: #DCDCDC;
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }




    .pricing-box {
    background: white;
    box-shadow: 0 3px 12px rgba(6, 11, 47, 0.06);
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;
    .pricing-icon-bg {
        background: rgba(#ffa409, 0.12);
        color: ffa409;
        display: block;
        height: 80px;
        width: 80px;
        line-height: 100px;
        margin: 0 auto;
        border-radius: 25% 25% 4% 25% / 25% 25% 4% 25%;
        box-shadow: 0 0 0 7px rgba(#ffa409, 0.03);
        transition: all 0.5s;
    }
    .pricing-item {
        li {
            padding: 10px 0;
        }
    }
    .pr-btn {
        position: relative;
        z-index: 1;
        color: #ffa409;
        border: 1px solid #ffa409;
        
    }
    .pr-btn:hover {
        background-color: #ffa409;
        color: #fff;
    }
    &:hover, &.active {
        .pricing-icon-bg {
            background-color: #ffa409;
            box-shadow: 0 0 0 7px rgba(ffa409, 0.06);
            color: white;
            border-radius: 4% 20% 20% 20% / 4% 20% 20% 20%;
        }
    }
}

.button-function {
    list-style: none;
    color: rgb(24, 45, 51);
    text-decoration: none;
    border-bottom: 1px solid;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 19px;
}
.button-function:hover {
    background-color: #ffa409;
    color: #fff;
    border: 1px solid #ffa409;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
.reduction-box {
    position: absolute;
    top: -10px;
    right: -15px;
    background-color: #63B545;
    font-weight: 450;
    box-shadow: 0 3px 12px rgba(6, 11, 47, 0.20);
    width: max-content;
    margin: 10px 10px 0 0;
    z-index: 1;
}
.lightning-box {
    position: absolute;
    top: -10px;
    font-weight: 450;
    width: max-content;
    margin: 10px 10px 0 0;
    z-index: 1;
    left: -10px!important;
}
.lightning-box img {
    width: 30px!important;
}
</style>
